export const PROVIDER_SYNC_CONFIG = {
  timeoutMs: 15000,
  intervalMs: 3000,
};

// paymentInfo.provider values whose approved applications are refreshed via provider-sync
export const PROVIDER_SYNC_PROVIDERS = ['ALLEGRO', 'ALLEGRO_CASH', 'ALL_WELL'];

// next_action values (offer update / sign contract steps) for which provider-sync runs
export const PROVIDER_SYNC_NEXT_ACTIONS = ['UPDATE_OFFER', 'SIGN_CONTRACT'];
